const PaidInclusionConstants = {
    CREDIT_CARD_FORM: {
        ID_SELECTOR: 'payment-form-iframe',
        CLASS_SELECTOR: 'payment-form',
        VERSION: 'v1',
    },
    PAYMENT_STATUS: {
        VALID: 'valid',
        INVALID: 'invalid',
        PENDING: 'pending',
    },
    PAYMENT_METHOD: {
        NEW: 'new',
        DEFAULT: 'default',
    },
    DEACTIVATE_OPTION: {
        NOW: 'now',
        EOT: 'end-of-term',
    },
    PAYMENT_PHASE: {
        SELECT_PAYMENT_METHOD: 'select payment method',
        CREDIT_CARD_CAPTURE: 'credit card capture',
        CREDIT_CARD_CHARGE: 'credit card charge',
        PUBLISH_LISTING: 'publish listing',
        CAUGHT_ERROR: 'caught error',
    },
    PRODUCT_TYPE: {
        1: 1,
        2: 2,
    },
    CAPTURE: {
        DEV: {
            SCRIPT_COMMONS:
                'https://static.candidate.zillow.net/billing/payment_method/v1/overall-commons-31cd94799c.js',
            SCRIPT_APP:
                'https://static.candidate.zillow.net/billing/payment_method/v1/credit-card-iframe/app-50ac2b012a.js',
        },
        PROD: {
            SCRIPT_COMMONS: 'https://www.zillowstatic.com/billing/payment_method/v1/overall-commons-31cd94799c.js',
            SCRIPT_APP: 'https://www.zillowstatic.com/billing/payment_method/v1/credit-card-iframe/app-50ac2b012a.js',
        },
        INITIATE: {
            ERROR: {
                METROID_MAINTENANCE_MODE: 'METROID_MAINTENANCE_MODE',
                CANNOT_MAKE_PAYMENTS: 'CANNOT_MAKE_PAYMENTS',
            },
        },
    },
    CHARGE: {
        DEV: {
            SCRIPT_COMMONS: 'https://s.zillow.net/billing/billing_integration/v1/overall-commons-1b9c46851c.js',
            SCRIPT_APP: 'https://s.zillow.net/billing/billing_integration/v1/charge/app-79894e0846.js',
        },
        PROD: {
            SCRIPT_COMMONS: 'https://s.zillowstatic.com/billing/live/v1/overall-commons-1b9c46851c.js',
            SCRIPT_APP: 'https://s.zillowstatic.com/billing/live/v1/charge/app-79894e0846.js',
        },
        INITIATE: {
            ERROR: {
                TRY_AGAIN_LATER: 'TRY_AGAIN_LATER',
                METROID_MAINTENANCE_MODE: 'METROID_MAINTENANCE_MODE',
                CANNOT_MAKE_PAYMENTS: 'CANNOT_MAKE_PAYMENTS',
                VALID_PAYMENT_EXISTS: 'VALID_PAYMENT_EXISTS',
            },
        },
    },
    ERROR_TYPE: {
        EXPIRATION_PAST: 'Expiration date must be a future date.',
        BAD_ZIP: 'Please enter a valid zip code.',
        INVALID_CARD_NUMBER: 'Invalid credit card number',
        PAYMENT_FAILURE: 'Transaction failed!',
        PAYMENT_PENDING: 'Your payment is pending. It may take up to 5 minutes to process. Please check back shortly.',
        METROID_MAINTENANCE_MODE: 'The payment service is currently down for maintenance. We\'ll be back up soon.' +
            ' Thank you for your patience.',
        CANNOT_MAKE_PAYMENTS: 'You cannot make payments for this listing.',
        DEFAULT: 'Something went wrong. Please refresh the page and try again.',
    },
};

export default PaidInclusionConstants;
